<template>
  <div id="buyerReceivedCommentsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-comment-arrow-down fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">نظرات دریافت شده</span>
                </div>
              </div>
              <div class="col-12  font-weight-bold">
                <span class="pointer profile-active-tab">نظرات پست ها</span>
              </div>

            </div>

            <div class="row">
              <div v-if="comments.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز نظری ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12">
                <div class="container">
                  <div v-for="item in comments" :key="item.id" class="row ">
                    <div class="col-12  mx-auto">
                      <div class="row">
                        <div class="col-4 p-1">
                          <v-img :height="$vuetify.breakpoint.xs ? 117 : 140" :src="$replaceHttps(item.ProductImageUrl)"
                                 class="rounded-lg">
                          </v-img>
                        </div>
                        <div class="col-8 px-0 d-flex flex-column justify-content-end text-left pl-2">
                          <router-link class="d-inline-block" :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.RelationID}}">
                            <i class="fa-solid fa-eye"></i> مشاهده کامل
                          </router-link>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-9 bg-white rounded-lg pl-1">
                          <v-avatar size="38">
                            <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)" alt="تصویر کاربر">
                            <i v-else class="fas fa-circle-user fa-3x"></i>

                          </v-avatar>
                          <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                          <span class="font-weight-normal">{{ item.Description }}</span>
                        </div>
                        <div class="col-3 text-left">
                          <div>{{ $convertDate(item.ModifiedDate) }}</div>
                          <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                        </div>
                        <div class="col-12">
                          <div class="row">
                            <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                            <div class="col-8 bg-white rounded-lg pb-0">
                              <span class="font-weight-bold mr-1">پاسخ شما :</span>
                              <span class="font-weight-normal">{{ item.AnswerDescription }}</span>
                            </div>
                            <div class="col-3 text-left py-0 reply-comments-action px-0">
                              <div>
                                <span class="d-inline-block w-50">{{ item.CountLike }}</span>
                                <v-btn class="d-inline-block w-50" icon small><i
                                    class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                              </div>
                              <div>
                                <span class="d-inline-block w-50">{{ item.CountDislike }}</span>
                                <v-btn class="d-inline-block w-50" icon small><i
                                    class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                              </div>
                              <div>
                                پاسخ
                                <v-btn icon  @click="openAnswerComment(item.VoteID)"><i class="fa-solid fa-reply fa-xl"></i>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
    </v-main>
    <v-bottom-sheet v-model="openSendCommentSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">

          <div class="col-auto font-weight-bold pr-8 primary-text">
            <i class="fa-solid fa-reply fa-xl" ></i>
            پاسخ
          </div>

          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openSendCommentSheet = !openSendCommentSheet">
              <i class="fa-regular fa-circle-xmark fa-xl"></i>

            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 ">
            <v-textarea
                v-model="answerDesc"
                auto-grow
                background-color="secondary"
                flat
                full-width
                hide-details
                placeholder="پاسخ خود را ینویسید ..."
                rows="4"
                solo>
            </v-textarea>
          </div>
          <div class="col-12 text-left pt-0 pl-0">
            <v-btn class="pl-1 pb-1" icon @click="registerAnswerComment">
              <i class="fa-solid fa-square-check fa-2x"></i>
            </v-btn>
          </div>

        </div>


      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "BuyerReceivedComments",
  metaInfo: {
    title: 'ایوان خانه- نظرات دریافت شده',
  },
  components: {BackBar},
  data: () => ({
    comments: [],
    showLoaderDialog:false,
    openSendCommentSheet:false,
    showResult:false,
    answerDesc: null,
    resultText: null,
    voteID: null,

  }),
  mounted() {
    this.getSocialCommentList()
  },
  methods: {
    getSocialCommentList() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/VoteManagement/_ListSocial", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.comments = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    openAnswerComment(id) {
      this.openSendCommentSheet = true
      this.voteID = id
    },
    registerAnswerComment() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", this.voteID);
      urlencoded.append("AnswerDescription", this.answerDesc);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/VoteManagement/_AnswerComment", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.answerDesc = null
            this.openSendCommentSheet = false
            this.getSocialCommentList()

          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
